import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/visitorRegistration/index', // 子服务入口登记页面
    name: 'visitorRegistrationIndex',
    component: () => import('@/sub-app/visitorRegistration/pages/index.vue'),
    meta: {
      title: '访客登记',
      keepAlive: false,
    },
  },
  {
    path: '/visitorRegistration/qrcodeReg', // 扫码登记页面
    name: 'visitorRegistrationQrcodeReg',
    component: () => import('@/sub-app/visitorRegistration/pages/qrcodeReg.vue'),
    meta: {
      title: '访客登记',
      keepAlive: false,
    },
  },
  {
    path: '/visitorRegistration/success',
    name: 'visitorRegistrationSuccess',
    component: () => import('@/sub-app/visitorRegistration/pages/success.vue'),
    meta: {
      title: '访客登记',
      keepAlive: false,
    },
  },
  {
    path: '/visitorRegistration/visitorRegList',
    name: 'visitorRegistrationRegList',
    component: () => import('@/sub-app/visitorRegistration/pages/visitorRegList.vue'),
    meta: {
      title: '访客登记',
      keepAlive: true,
    },
  },
  {
    path: '/visitorRegistration/visitorRegDetail',
    name: 'visitorRegistrationRegDetail',
    component: () => import('@/sub-app/visitorRegistration/pages/visitorRegDetail.vue'),
    meta: {
      title: '临时通行卡',
    },
  },
  {
    path: '/visitorRegistration/visitorApprove',
    name: 'visitorRegistrationApprove',
    component: () => import('@/sub-app/visitorRegistration/pages/visitorApprove.vue'),
    meta: {
      title: '访客审核',
      keepAlive: true,
    },
  },
  {
    path: '/visitorRegistration/visitorApproveDetail',
    name: 'visitorRegistrationApproveDetail',
    component: () => import('@/sub-app/visitorRegistration/pages/visitorApproveDetail.vue'),
    meta: {
      title: '申请详情',
      keepAlive: false,
    },
  },
  {
    path: '/visitorRegistration/faceProtocal',
    name: 'visitorRegistrationFaceProtocal',
    component: () => import('@/sub-app/visitorRegistration/pages/faceProtocal.vue'),
    meta: {
      title: '',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
